import { MessageFlashIcon } from './MessageFlashIcon';

/**
 * author: Google
 * id A9181976-10D1-4CB7-993E-AE8B7DEDEC64
 * name message-flash
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-flash.svg
 * tags
 */
export const MessageQuickIcon = MessageFlashIcon;
export default MessageQuickIcon